<template>
    <div class="row action-bar">
        <div class="col-md-1 pt-2">Действие:</div>
        <div class="col-md-4 pt-1">
            <select class="form-control" v-model="selectedAction" @change="actionChanged">
                <option v-for="item in actions" :value="item.code">{{item.title}}</option>
            </select>
        </div>
        <div v-show="actionOptions.length" class="col-md-5 pt-1">
            <Select2
                    :options="actionOptions"
                    :settings="{multiple:true, language:'ru'}"
                    :placeholder="getActionPlaceholder()"
                    v-model="selectedIds"
            />
        </div>
        <div class="col-md-2 pt-1">
            <button class="btn btn-primary" :disabled="!isValid()" v-on:click="execute">Выполнить</button>
        </div>
    </div>
</template>

<script>
  export default {
    name: "ActionBar",
    components: {},
    props: {
      actions: Array,
      autoReset: {
        type: Boolean,
        default: true
      },
      defaultAction: String
    },
    data() {
      return {
        actionOptions: [],
        selectedAction: '',
        selectedIds: []
      };
    },
    methods: {
      execute() {
        this.$emit('execute', {code: this.selectedAction, ids: this.selectedIds});
        if (this.autoReset) {
          this.selectedIds = [];
          this.init();
        }
      },
      actionChanged() {
        this.updateActionOptions();
      },
      getActionPlaceholder() {
        const action = this.actions.find(x => x.code === this.selectedAction);
        if (action && action.placeholder) {
          return action.placeholder;
        }
        return 'Выберите элемент';
      },
      isValid() {
        return (this.selectedAction && (!this.actionOptions.length || this.selectedIds.length));
      },
      updateActionOptions() {
        const action = this.actions.find(x => x.code === this.selectedAction);
        if (action.options && action.options.length) {
          this.actionOptions = action.options;
        } else {
          this.actionOptions = [];
        }
      }
    },
    watch: {
      actions: {
        handler() {
          if (this.defaultAction && !this.selectedAction) {
            this.selectedAction = this.defaultAction;
            this.$nextTick(this.updateActionOptions);
          }
        },
        deep: true
      }
    }
  }
</script>

<style lang="scss" scoped>
    .action-bar {
        padding: 16px 0 16px 0;
    }
</style>